import React from 'react';
import { Link } from 'react-router-dom';
import ThemeIcon from '../ThemeIcon/ThemeIcon';
import './Service.scss';

const Service = ({ serviceList, accreditedFlag }) => {
    const {title,description, icon} = serviceList;

    const accredited = accreditedFlag;
    return (
        <div className='col-lg-4 col-md-4 col-sm-6 col-6'>
           <div className="service-box">
                <div className="service-icon">
                    <div className='icon-area'>
                    <ThemeIcon icon={icon} />
                    </div>
                </div>
                <div className="service-text">
                    {/* <h3><Link to="/singleservice">{title}</Link></h3> */}
                    <h3>{title}</h3>
                    <p>{description}</p>
                </div>
           </div>
        </div>
    );
};

export default Service;